var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSamlApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/SAML app") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/SAML-app"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F4FB",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.444,25.822 C9.076,25.822 8.764,25.759 8.508,25.633 C8.252,25.507 8.034,25.344 7.854,25.144 L8.454,24.538 C8.738,24.858 9.088,25.018 9.504,25.018 C9.728,25.018 9.894,24.972 10.002,24.88 C10.11,24.788 10.164,24.666 10.164,24.514 C10.164,24.398 10.132,24.301 10.068,24.223 C10.004,24.145 9.874,24.092 9.678,24.064 L9.264,24.01 C8.82,23.954 8.495,23.82 8.289,23.608 C8.083,23.396 7.98,23.114 7.98,22.762 C7.98,22.574 8.016,22.402 8.088,22.246 C8.16,22.09 8.263,21.956 8.397,21.844 C8.531,21.732 8.695,21.645 8.889,21.583 C9.083,21.521 9.304,21.49 9.552,21.49 C9.868,21.49 10.146,21.54 10.386,21.64 C10.626,21.74 10.832,21.886 11.004,22.078 L10.398,22.69 C10.298,22.574 10.177,22.479 10.035,22.405 C9.893,22.331 9.714,22.294 9.498,22.294 C9.294,22.294 9.142,22.33 9.042,22.402 C8.942,22.474 8.892,22.574 8.892,22.702 C8.892,22.846 8.931,22.95 9.009,23.014 C9.087,23.078 9.214,23.124 9.39,23.152 L9.804,23.218 C10.236,23.286 10.556,23.419 10.764,23.617 C10.972,23.815 11.076,24.096 11.076,24.46 C11.076,24.66 11.04,24.844 10.968,25.012 C10.896,25.18 10.791,25.324 10.653,25.444 C10.515,25.564 10.344,25.657 10.14,25.723 C9.936,25.789 9.704,25.822 9.444,25.822 Z M15.112,25.75 L14.812,24.754 L13.414,24.754 L13.114,25.75 L12.19,25.75 L13.57,21.562 L14.698,21.562 L16.06,25.75 L15.112,25.75 Z M14.122,22.39 L14.092,22.39 L13.63,23.98 L14.59,23.98 L14.122,22.39 Z M20.474,23.002 L20.456,23.002 L20.15,23.614 L19.334,25.096 L18.536,23.62 L18.218,22.96 L18.2,22.96 L18.2,25.75 L17.342,25.75 L17.342,21.562 L18.308,21.562 L19.334,23.524 L19.346,23.524 L20.36,21.562 L21.332,21.562 L21.332,25.75 L20.474,25.75 L20.474,23.002 Z M22.956,25.75 L22.956,21.562 L23.868,21.562 L23.868,24.94 L25.464,24.94 L25.464,25.75 L22.956,25.75 Z",
    id: "Path-2",
    fill: "#222945",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,6.75 L27,6.75 L27,20 L7,20 L7,6.75 Z M13.25,9.5625 L13.25,11.4375 L24.5,11.4375 L24.5,9.5625 L13.25,9.5625 Z M12,9.25 L9.5,9.25 L9.5,11.75 L12,11.75 L12,9.25 Z",
    id: "Shape",
    fill: "#94BD91",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamlApp);
export default __webpack_public_path__ + "static/media/SAML-app.02f82aaa7d2c8dbd7e6f21e3af87b2d6.svg";
export { ForwardRef as ReactComponent };